module.exports = __webpack_public_path__ + "media/auto_main_information/dowod_zatrzymany-091d590a.svg";